
import { Component, Mixins, Prop, } from "vue-property-decorator";
import { ReceptionComment, ReceptionCommentSet, } from "../../../../domain/workflow/reception";
import { ReceptionCommentKinds, ReceptionCommentSortItemKinds } from "../../../../domain/workflow/kinds";
import { CommentDisplayMixin, CommentUpdaterMixin, } from "../../lists/tables/mixins";

@Component
export default class ReceptionDetailEditorCommentTabSelectorMixin extends Mixins(CommentDisplayMixin, CommentUpdaterMixin) {
  @Prop()
  commentSet: ReceptionCommentSet;

  data(): any {
    return {
      nextMessageSortType: null,
      commentSortType: null,
      restrictCommentSortType: null,
    };
  }

  // コメントの並び順を指定するラジオボタンの選択値
  // CommentTable内に持たせるのが正解だが以下の理由からここに持つ.
  // ・記載者用タブと管理者用タブをv-ifで切り替えてるので切り替えるとコンポーネントが破棄されて状態保持できない.
  // ・v-showで切り替えると切替後に垂直方向のスクロールバー表示がおかしくなる問題が出て簡単に解決できない.
  //    →DOMレンダリングがおかしいのでなくelement-uiが間違ったstyleを指定してる模様.
  nextMessageSortType: ReceptionCommentSortItemKinds;
  commentSortType: ReceptionCommentSortItemKinds;
  restrictCommentSortType: ReceptionCommentSortItemKinds;

  get commentTitle(): string {
    return this.getCommentLabel(ReceptionCommentKinds.Comment);
  }

  get restrictCommentTitle(): string {
    return this.getCommentLabel(ReceptionCommentKinds.Restrict);
  }

  get nextMessageTitle(): string {
    return this.getCommentLabel(ReceptionCommentKinds.NextMessage);
  }

  get nextMessages(): ReceptionComment[] {
    return this.commentSet
      ? this.commentSet.nextMessages
      : [];
  }

  get comments(): ReceptionComment[] {
    return this.commentSet
      ? this.commentSet.comments
      : [];
  }

  get restrictComments(): ReceptionComment[] {
    return this.commentSet
      ? this.commentSet.restrictComments
      : [];
  }

  showCommentDialog(kind: ReceptionCommentKinds, title: string, comment: ReceptionComment, commentSet: ReceptionCommentSet, label: string): void {
    // view側で実装
  }

  async confirmDeleteComment(kind: ReceptionCommentKinds): Promise<number> {
    // view側で実装
    return null;
  }

  async deleteCommentCommon(kind: ReceptionCommentKinds, comment: ReceptionComment): Promise<void> {
    const confirmResult = await this.confirmDeleteComment(kind);
    if (confirmResult == null) { // 登録キャンセルした
      return;
    }

    this.execDeleteComment(kind, comment);
  }

  private getCommentCommon(row: ReceptionComment, kind: ReceptionCommentKinds): ReceptionComment {
    if  (!!row && row instanceof ReceptionComment) { return row; }
    
    switch (kind) {
      case ReceptionCommentKinds.Comment:
        return this.comments[0];
      case ReceptionCommentKinds.Restrict:
        return this.restrictComments[0];
      case ReceptionCommentKinds.NextMessage:
        return this.nextMessages[0];
      default:
        return null;
    }
  }

  addComment(): void {
    this.showCommentDialog(ReceptionCommentKinds.Comment, this.commentTitle, null, null, this.commentTitle);
  }

  editComment(row: ReceptionComment): void {
    this.showCommentDialog(ReceptionCommentKinds.Comment, this.commentTitle + "編集", this.getComment(row), null, this.commentTitle);
  }

  deleteComment(row: ReceptionComment): void {
    this.deleteCommentCommon(ReceptionCommentKinds.Comment, this.getComment(row));
  }

  private getComment(row: ReceptionComment): ReceptionComment {
    return this.getCommentCommon(row, ReceptionCommentKinds.Comment);
  }

  addNextMessage(): void {
    this.showCommentDialog(ReceptionCommentKinds.NextMessage, this.nextMessageTitle, null, this.commentSet, this.nextMessageTitle);
  }

  editNextMessage(row: ReceptionComment): void {
    this.showCommentDialog(ReceptionCommentKinds.NextMessage, this.nextMessageTitle + "編集", this.getNextMessage(row), this.commentSet, this.nextMessageTitle);
  }

  deleteNextMessage(row: ReceptionComment): void {
    this.deleteCommentCommon(ReceptionCommentKinds.NextMessage, this.getNextMessage(row));
  }

  private getNextMessage(row: ReceptionComment): ReceptionComment {
    return this.getCommentCommon(row, ReceptionCommentKinds.NextMessage);
  }

  addRestrictComment(): void {
    this.showCommentDialog(ReceptionCommentKinds.Restrict, this.restrictCommentTitle, null, null, this.restrictCommentTitle);
  }

  editRestrictComment(row: ReceptionComment): void {
    this.showCommentDialog(ReceptionCommentKinds.Restrict, this.restrictCommentTitle + "編集", this.getRestrictComment(row), null, this.restrictCommentTitle);
  }

  deleteRestrictComment(row: ReceptionComment): void {
    this.deleteCommentCommon(ReceptionCommentKinds.Restrict, this.getRestrictComment(row));
  }

  private getRestrictComment(row: ReceptionComment): ReceptionComment {
    return this.getCommentCommon(row, ReceptionCommentKinds.Restrict);
  }
}
